export default {
    'page': {
        component: import('@/components/integrations/protokol/mail/Index'),
        permissions: ['manage']
    },

    'home': {
        component: import('@/components/integrations/protokol/mail/Home'),
        permissions: ['manage']
    },

    'menu': {
        component: import('@/components/integrations/protokol/mail/Menu'),
        permissions: ['manage']
    }
}
